<div class="header-container">
  <div class="d-inline-flex">
    <div class="logo me-3">
      <img src="assets/images/MWP_Blue_Main_Logo.webp" alt="My workplace logo" />
    </div>
    @if (links) {
    <div class="header-divider me-3">
    </div>
    <div class="nav-links">
      @if (!isVersionError) {
      <ul>
        @for (link of links; track link.label) {
        <li>
          @if (link.menuLinks) {
          <div [matMenuTriggerFor]="headerMenu" class="header-menu" [ngClass]="isHeaderLinkActive(link.link)? 'active-link' : ''">
            <div class="menu-header-content">
              <mwp-text-translate class="m-0" [text]="link.label" [jsonKey]="link.label" />
              <div>
                <mwp-svg-icon [SvgMatType]="svgType.ArrowDropDown" />
              </div>
            </div>
          </div>
          <mat-menu #headerMenu="matMenu" xPosition="after">
            @for (menuLink of link.menuLinks; track menuLink.link) {
            <button mat-menu-item [routerLink]="menuLink.link" routerLinkActive="active-link" class="header-menu-button">
              <div class="d-flex align-items-center">
                <div>
                  <mwp-text-translate [text]="menuLink.label" [jsonKey]="menuLink.label" />
                </div>
              </div>
            </button>
            }
          </mat-menu>
          } @else {
          @if (link.isIconOnly) {
          <div class="header-menu" [ngClass]="isHeaderLinkActive(link.link)? 'active-link' : ''">
            <div class="menu-header-content no-menu icon-only" (click)="navigateToURL(link.link)">
              <mwp-svg-icon [SvgMatType]="link.svg" className="svg-flex" class="m-0" />
            </div>
          </div>
          } @else {
          <div class="header-menu" [ngClass]="isHeaderLinkActive(link.link)? 'active-link' : ''">
            <div class="menu-header-content no-menu" (click)="navigateToURL(link.link)">
              <mwp-text-translate class="m-0" [text]="link.label" [jsonKey]="link.label" />
            </div>
          </div>
          }
          }
        </li>
        }
      </ul>
      }
    </div>
    }
  </div>
  <div class="settings-icon-container">
    <div class="header-divider h-100">
    </div>
    <div class="d-inline-flex">
      @if (isMember) {
      <div class="d-inline-flex align-items-center ms-3">
        <mwp-svg-icon [SvgMatType]="svgType.Person" />
        <div class="ms-1">
          {{ memberName }}
        </div>
      </div>
      <div class="d-inline-flex align-items-center ms-3">
        <mwp-svg-icon [SvgMatType]="svgType.Badge" class="m-0" />
        <div class="ms-1">
          {{ memberSID }}
        </div>
      </div>
      <div class="d-inline-flex align-items-center ms-3">
        <mwp-svg-icon [SvgMatType]="svgType.Company" />
        <div class="ms-1">
          {{ companyName }}
        </div>
      </div>
      }
      @if (isAgent) {
      <div class="d-inline-flex align-items-center ms-3">
        <mwp-svg-icon [SvgMatType]="svgType.Group" />
        <div class="ms-1">
          {{ agentName }}
        </div>
      </div>
      }
      @if (isAdmin) {
      <div class="d-inline-flex align-items-center ms-3">
        <mwp-svg-icon [SvgMatType]="svgType.Groups" />
        <div class="ms-1">
          {{ adminName }}
        </div>
      </div>
      }
    </div>
    <div class="header-divider h-100 ms-3 me-1">
    </div>
    @if (operatingMode) {
    <div class="operating-mode d-inline-flex me-0 ms-2">
      <mwp-svg-icon [SvgMatType]="svgType.Wrench" />
      <div class="fw-bold">
        {{ operatingMode }}
      </div>
    </div>
    }
    @if (!isVersionError) {
    <div class="d-flex align-items-center ms-2 gear-icon">
      <mwp-svg-icon [SvgMatType]="svgType.Gear" [matMenuTriggerFor]="rootMenu" tooltipPosition="bottom" />
      <mat-menu #rootMenu="matMenu" class="mat-menu-gearbox" xPosition="before">
        <ul>
          <!-- <li class="pb-1 w-100 d-flex justify-content-center">
              <mat-slide-toggle [(ngModel)]="isDarkMode" (change)="onDarkModeChange($event)">
                <div class="ms-1">
                  <mwp-text-translate text="DARK MODE" jsonKey="darkMode" />
                </div>
              </mat-slide-toggle>
            -->
          <!-- <li>
            <div class="copyright-info">
              <div id="DigiCertClickID_j_hI2FlP">
                <mwp-thawte></mwp-thawte>
              </div>
              <div class="ms-2 align-content-center">
                <div class="text-center">
                  {{ copyright }}
                </div>
                <div class="text-center">
                  {{ appVersion }}
                </div>
              </div>
            </div>
          </li> -->
          @if (isUpdateRegisteredEmailVisbile) {
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="openUpdateRegisteredEmailDialog()">
              <mwp-text-translate text="Update Registered Email" jsonKey="updateRegistedEmail" />
            </button>
          </li>
          }
          @if (isChangePasswordVisbile) {
          <li class="pb-1 w-100 ">
            <button mat-menu-item class="w-100" (click)="openUpdatePasswordDialog()">
              <mwp-text-translate text="Change Password" jsonKey="changePassword" />
            </button>
          </li>
          }
          @if (isAgent && isMember) {
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="agentExitMemberSession()">
              <mwp-text-translate text="Exit Member Session" jsonKey="exitMemberSession" />
            </button>
          </li>
          }
          @if (isAgent && !isMember) {
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="openMFADialog()">
              <mwp-text-translate text="Update Multi-Factor Authentication" jsonKey="updateMFA" />
            </button>
          </li>
          }
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="openLanguageDialog()">
              <mwp-text-translate text="Change Language" jsonKey="changeLanguage" />
            </button>
          </li>
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="openSupportDialog()">
              <mwp-text-translate text="Support" jsonKey="support" />
            </button>
          </li>
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="navigateToURL(BaseModulePaths.TermsOfService)">
              <mwp-text-translate text="Terms of Service" jsonKey="termsOfService" />
            </button>
          </li>
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="navigateToURL(BaseModulePaths.PrivacyPolicy)">
              <mwp-text-translate text="Privacy Policy" jsonKey="privacyPolicy" />
            </button>
          </li>
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="navigateToURL(BaseModulePaths.DataProcessingAddendum)">
              <mwp-text-translate text="Data Processing Addendum" jsonKey="dataProcessingAddendum" />
            </button>
          </li>
          <li class="pb-1 w-100">
            <button mat-menu-item class="w-100" (click)="openLogoutDialog()">
              <mwp-text-translate text="Logout" jsonKey="logout" />
            </button>
          </li>
        </ul>
      </mat-menu>
    </div>
    }
  </div>